<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vMM0Sj/tc-custom/9781681880624.jpg?1721442278220" alt="This image is the cover for the book Cookies, Brownies & Bars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cookies, Brownies & Bars
      </h1>
      <p class="bookDescription body article font2">
        <b>Treats to suit any occasion—from fudgy brownies to sophisticated macaroons—served up by the award-winning pastry chef and author of <i>Big Fat Cookies</i>.</b><br/><br/> Sweet, gooey chocolate chip cookies in lunch boxes; beautifully decorated holiday treats wrapped and mailed with care; and rich, moist brownies and bars overflowing from a picnic basket: these and many other recipes and ideas can be found in the pages of <i>Cookies, Brownies &amp; Bars</i>.<br/><br/> Recipes include:<br/> French-Style Pistachio Macaroons<br/> Mexican Wedding Cookies<br/> Triple Chocolate Chunk Cookies<br/> Tart Key Lime Squares<br/> Toasted Hazelnut Biscotti<br/> Cream Cheese Marble Brownies<br/> Crunchy Espresso Shortbread<br/> Cream-Filled Pecan Lace Cookies<br/> Pink Raspberry Pinwheels<br/><br/><b>Praise for Elinor Klivans and her baking books</b><br/><br/> “Elinor Klivans is a name you may not know—you should—but it is quite possible you have tasted her food . . . Many, many home bakers depend on her books, her recipes and her expertise. Try one of the chocolate chip cookies and you’ll understand . . . a baking treasure.” —<i>Cooking by the Book</i><br/><br/> “Another recipe I love is the one for these dreamy lemon ripple cheesecake swirl bars from Camden, Maine-based cookbook author and ‘cheesecake specialist’ Elinor Klivans, and I’m not alone—they’ve been a huge fan favorite at <i>F&amp;W</i> ever since we published the recipe over 10 years ago.” —<i>Food &amp; Wine</i><br/><br/> “Appealing . . . a combination cookbook, memoir and travelogue.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elinor Klivans
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d9f1d42